export default __webpack_public_path__ + "assets/breakfast-partners/placeholder.f6d585a3f3ca1f2dc255322a818e19b8.svg";